import { CymaticField } from "../CymaticField/CymaticField"

export interface SofiaMarkProps {
  /** Rendered width and height in pixels. */
  size?: number
  className?: string
  /** Plays the thinking animation; at rest the mark holds the static logo. */
  animated?: boolean
}

/**
 * Sofia's mark. It rests as the current resonance-tile logo and becomes a
 * continuously morphing particle reel while Sofia thinks.
 */
export function SofiaMark({
  size = 28,
  className,
  animated = false,
}: SofiaMarkProps) {
  return (
    <CymaticField
      role="img"
      aria-label="Sofia"
      size={size}
      animated={animated}
      className={className}
    />
  )
}
